export default __webpack_public_path__ + "static/media/food10.94e0964f.jpg";